module.exports = __webpack_public_path__ + "static/media/crispina.dbf7eaa9.jpg";